import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData } from '../models/dialog-data';

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'message-dialog',
    templateUrl: './message-dialog.html',
    styleUrls: ['./message-dialog.scss']
})
export class MessageDialogComponent {
    public forConfirmation;
    constructor(
        public dialogRef: MatDialogRef<MessageDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
        this.forConfirmation = data.forConfirmation;
    }
    public close(userConfirmed = false) {
        this.dialogRef.close(userConfirmed);
    }
}
